<template>
    <div v-if="!loading" class="pb-2">
        <b-alert variant="danger" show>
            <p class="alert-body text-center">
                مبلغ کل شارژ مانده در پنل پیامکی مجموعه ها :
                {{ smsManagementData.remainChargesAmount.toLocaleString('fa-IR') }}
                ریال است.
            </p>
        </b-alert>
        <b-card>
            <div class="d-flex justify-content-between align-items-center mb-2 mx-50">
                <h3 class="text-primary mb-0">تنظیمات پیامک</h3>
                <b-button @click="editSmsTemplates" :disabled="loadingButton" variant="primary" class="d-flex">
                    <span>ذخیره تغییرات</span>
                    <b-spinner v-if="loadingButton" class="ml-50" variant="white" small></b-spinner>
                </b-button>
            </div>
            <div v-for="(item, index) in smsManagementData.smsTemplates" :key="`smsManagement${index}`"
                class="mt-2 border-info rounded p-2">
                <h5>نام کلید : {{ item.key }}</h5>
                <h5 class="mb-2">تعداد ارسال شده : {{ item.usageCount }}</h5>
                <b-form-group label="نام پیام" label-for="smsNameId">
                    <b-form-input autocomplete="off" dir="rtl" id="smsNameId" v-model="item.name" name="smsName"
                        class="user-select-none" />
                </b-form-group>

                <b-form-group label="توضیحات پیام" label-for="smsDescriptionId">
                    <b-form-input autocomplete="off" dir="rtl" id="smsDescriptionId" v-model="item.description"
                        name="smsDescription" class="user-select-none" />
                </b-form-group>
                <b-form-group label="متن پیام" label-for="messageId">
                    <b-form-textarea v-model="item.message" dir="rtl" id="messageId" class="text-primary-middle"
                        rows="4" no-resize spellcheck="false" name="message" />
                </b-form-group>
            </div>
        </b-card>
    </div>
</template>

<script>
import { BCard, BCardText, BLink, BRow, BCol, BButton, BImg, BAvatar, BTable, BPagination, BFormInput, BFormGroup, BSpinner, BAlert, BFormTextarea } from 'bootstrap-vue';
import { adminService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BLink,
        BRow,
        BCol,
        BButton,
        BImg,
        BAvatar,
        BTable,
        BPagination,
        BFormInput,
        BFormGroup,
        BSpinner,
        BAlert,
        BFormTextarea
    },
    data() {
        return {
            loading: true,
            loadingButton: false,
            fields: [
                {
                    key: 'name',
                    label: 'نام',
                },
                {
                    key: 'description',
                    label: 'توضیحات',
                },
                {
                    key: 'price',
                    label: 'مبلغ (ریال)',
                },
                {
                    key: 'usageCount',
                    label: 'تعداد ارسال شده',
                },
                {
                    key: 'key',
                    label: 'کلید',
                },
                {
                    key: 'edit',
                    label: 'ویرایش',
                },
            ],
            smsManagementData: [],
        }
    },
    methods: {
        getSmsManagement() {
            adminService.smsManagement().then(({ data }) => {
                this.smsManagementData = data
                this.loading = false
            })
        },
        editSmsTemplates() {
            this.loadingButton = true
            let data = {
                items: []
            }
            this.smsManagementData.smsTemplates.forEach((item) => {
                data.items.push({
                    name: item.name,
                    message: item.message,
                    key: item.key,
                    description: item.description
                })
            })
            adminService.editSmsTemplates(data).then(({ data }) => {
                this.loadingButton = false
                this.getSmsManagement()
            })
        },
    },
    mounted() {
        this.getSmsManagement()
    },
};
</script>